// import Vue from 'vue'
// import axios from 'axios'
// import swal from 'sweetalert'
const state = {
  showfront: true,
  notfound: false,
  showregister: false,
  showlogin: false,
  renvoiemail: false,
  smsvalidation: false,
  searchUrl: false,
  isTitle: false,
  indicatif: ''
}
const mutations = {
  SHOW_FRONT: (state, value) => {
    state.showfront = value
  },
  SHOW_ADMIN: (state, value) => {
    state.showadmin = value
  },
  SHOW_NOT_FOUND: (state, value) => {
    state.notfound = value
  },
  SHOW_REGISTER: (state, value) => {
    state.showregister = value
  },
  SHOW_LOGIN: (state, value) => {
    state.showlogin = value
  },
  SHOW_RENVOIEMAIL: (state, value) => {
    state.renvoiemail = value
  },
  SHOW_SMSVALIDATION: (state, value) => {
    state.smsvalidation = value
  },
  FULL_WIDTH: (state, value) => {
    state.searchUrl = value
  },
  ADD_TITLE: (state, value) => {
    state.isTitle = value
  },
  SET_INDICATIF: (state, value) => {
    state.indicatif = value
  }
}
const actions = {
  showFront (store, value) {
    store.commit('SHOW_FRONT', value)
  },
  showrRegister (store, value) {
    store.commit('SHOW_REGISTER', value)
  },
  setIndicatif (store, value) {
    store.commit('SET_INDICATIF', value)
  }
}
const getters = {
  showfront: state => state.showfront,
  showregister: state => state.showregister,
  showlogin: state => state.showlogin,
  renvoiemail: state => state.renvoiemail,
  smsvalidation: state => state.smsvalidation,
  searchUrl: state => state.searchUrl,
  isTitle: state => state.isTitle,
  indicatif: state => state.indicatif
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/route.js